import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getWristbands(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("wristbands?" + parameters);
  return data;
}

export async function getWristband(id) {
  const {data} = await axios.get("wristbands/" + id);
  return data;
}

export async function getPreview(id) {
  const { data } = await axios.get("wristbands/" + id + "/preview", { responseType: 'arraybuffer' });

  return btoa(
      new Uint8Array(data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
      ),
  );
}

export async function createWristband(values) {
  const { data } = await axios.post("wristbands", values);
  return data;
}

export async function updateWristband(id, values) {
  const { data } = await axios.patch("wristbands/" + id, values);
  return data;
}

export async function deleteWristband(id) {
  const { data } = await axios.delete("wristbands/" + id);
  return data;
}
